<template>
  <div>
    <div class="card" v-show="!isLoading">
      <font-awesome-icon
        icon="star"
        class="star"
        :class="timePackageItem.favorite ? 'star-gold' : ''"
        v-if="withStars"
        @click="handleStarClick"
      />
      <img
        @click="redirect(timePackageItem)"
        :id="timePackageItem.id"
        alt="
      Nauli,
      anatomia jogi.
      kręgosłup,
      joga wzmacniająca,
      kurs jogi online,
      joga online,
      filmy jogi,
      techniki oddechowe,
      joga balanse,
      joga video,
      uważna praktyka,
      praktyka dla początkujących
      "
        style="position: relative"
        loading="lazy"
      />
      <!-- 
      <div
        class="nameContent"
        @click="redirect(timePackageItem)"
        v-html="timePackageItem.name"
        :style="
          (isSubcategory && numberOfMoviesInSubcategories) ||
          timePackageItem.numberOfTimePackageItems
            ? 'bottom: 2rem'
            : ''
        "
      ></div>
      <div
        v-if="
          (isSubcategory && numberOfMoviesInSubcategories) ||
            timePackageItem.numberOfTimePackageItems
        "
        class="numberOfVideos"
        @click="redirect(timePackageItem)"
      >
        {{
          timePackageItem.numberOfTimePackageItems ||
            numberOfMoviesInSubcategories
        }}
        <img
          style="opacity: 100% !important"
          src="../assets/videos-icon.svg"
          alt="videos-icon"
        />
      </div> -->

      <div
        v-if="
          this.activeSubscriptions &&
            this.activeSubscriptions.length < 2 &&
            this.activeSubscriptions[0].freeForRegistration &&
            timePackageItem.includedInFreeSubscription
        "
        class="freeSubscription"
        @click="redirect(timePackageItem)"
      >
        Dostępne za darmo przez 24h
      </div>
    </div>
    <div
      class="mt-1"
      v-if="
        timePackageItem &&
          !isSubcategory &&
          !timePackageItem.numberOfTimePackageItems &&
          !isExtendedSubscription
      "
    >
      <add-video-to-schedule
        :selectedVideo="timePackageItem"
        :withoutMargin="true"
      />
    </div>
    <div v-else class="mt-1 mb-5"></div>
    <div
      class="under-card-text"
      style="cursor:pointer;"
      @click="redirect(timePackageItem)"
    >
      <h2 v-html="timePackageItem.name"></h2>
      <div>
        <svg
          width="60"
          height="12"
          viewBox="0 0 101 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100.707 8.70711C101.098 8.31658 101.098 7.68342 100.707 7.29289L94.3431 0.928932C93.9526 0.538408 93.3195 0.538408 92.9289 0.928932C92.5384 1.31946 92.5384 1.95262 92.9289 2.34315L98.5858 8L92.9289 13.6569C92.5384 14.0474 92.5384 14.6805 92.9289 15.0711C93.3195 15.4616 93.9526 15.4616 94.3431 15.0711L100.707 8.70711ZM0 9L100 9V7L0 7L0 9Z"
            fill="#6D6963"
          />
        </svg>
      </div>
      <div
        v-if="
          timePackageItem.numberOfTimePackageItems > 0 ||
            numberOfMoviesInSubcategories > 0
        "
        class="number-of-videos"
      >
        {{
          timePackageItem.numberOfTimePackageItems ||
            numberOfMoviesInSubcategories
        }}
        Wideo
      </div>
    </div>

    <div class="card-hidden" v-show="isLoading"></div>
  </div>
</template>

<script>
import axios, { SERVER_URL } from "../axios";
import router from "../router";
import AddVideoToSchedule from "./AddVideoToSchedule.vue";

export default {
  components: { AddVideoToSchedule },
  name: "Course",
  props: {
    timePackageItem: Object,
    newCourses: Boolean,
    homePractiseCourses: Boolean,
    withStars: Boolean,
    currentCategory: String,
    freeSubscription: Boolean,
    selectedSubCategoryId: String,
    isSubcategory: Boolean,
    numberOfTimePackageItems: Number,
    isExtendedSubscription: Boolean,
  },

  data() {
    return {
      isLoading: false,
      numberOfMoviesInSubcategories: 0,
    };
  },

  watch: {
    async timePackageItem(item) {
      this.isLoading = true;
      if (item) {
        await this.loadImage(item.id);
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 50);
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.isSubcategory && this.timePackageItem && this.timePackageItem.id) {
      this.getNumberOfMoviesInSubcategory(this.timePackageItem.id);
    }
    if (this.timePackageItem) {
      await this.loadImage(this.timePackageItem);
    }
    setTimeout(() => {
      this.isLoading = false;
    }, 50);
  },
  computed: {
    activeSubscriptions() {
      return this.$store.getters["timePackages/getActiveSubscriptions"];
    },
  },
  methods: {
    async getNumberOfMoviesInSubcategory(subcategoryId) {
      const response = await axios.get(
        `/subCategories/${subcategoryId}/numberOfMovies?forExtended=${
          this.isExtendedSubscription ? true : false
        }`
      );
      if (response && response.data && response.data.numberOfMovies) {
        this.numberOfMoviesInSubcategories = response.data.numberOfMovies;
      } else {
        return 0;
      }
    },
    async handleStarClick() {
      if (!this.timePackageItem.favorite) {
        await this.$store.dispatch("timePackages/addToFavorite", {
          timePackageItemId: !this.isExtendedSubscription
            ? this.timePackageItem.id
            : null,
          timePackageItemExtendedId: this.isExtendedSubscription
            ? this.timePackageItem.id
            : null,
          categoryId: this.currentCategory,
          favorites: this.currentCategory === "favourites" ? true : false,
          lastWatched: this.currentCategory === "lastWatched" ? true : false,
        });
      } else {
        await this.$store.dispatch("timePackages/deleteFromFavourites", {
          favoriteItemId: this.timePackageItem.favoriteItemId,
          categoryId: this.currentCategory,
          favorites: this.currentCategory === "favourites" ? true : false,
          lastWatched: this.currentCategory === "lastWatched" ? true : false,
          isExtendedSubscription: this.isExtendedSubscription,
        });
      }
    },
    async loadImage(timePackageItem) {
      const element = document.getElementById(timePackageItem.id);
      if (element) {
        if (timePackageItem.imagePath) {
          const extension = timePackageItem.imagePath?.split(".")[1];
          if (this.isSubcategory) {
            element.src = `${SERVER_URL}${timePackageItem.id}.${extension}`;
          } else {
            element.src = `${SERVER_URL}${timePackageItem.id}.${extension}`;
          }
        }
      }
    },
    redirect(timePackageItem) {
      const currentRouteName = this.$route.name;
      if (!this.isSubcategory && !timePackageItem.numberOfTimePackageItems) {
        window.localStorage.setItem(
          "selectedCourse",
          `course_${timePackageItem.id}`
        );
        axios.post(`timePackageItems/${this.timePackageItem.id}/viewsCounter`);
        this.$store.dispatch("videos/setSelectedVideo", {
          video: this.timePackageItem,
        });

        if (!this.isExtendedSubscription) {
          this.$router.push({
            name: "VideosDemo",
            params: {
              course: this.timePackageItem,
              path:
                currentRouteName && currentRouteName === "Courses"
                  ? "subskrypcja"
                  : currentRouteName &&
                    currentRouteName === "CoursesForBeginners"
                  ? "subskrypcja-podstawy"
                  : timePackageItem.movieSubcategoryL2
                  ? `podkategoria/${timePackageItem.movieSubcategoryL2.id ||
                      timePackageItem.movieSubcategoryL2}`
                  : this.selectedSubCategoryId
                  ? `kategoria/${this.selectedSubCategoryId}`
                  : "subskrypcja",
            },
            query: {
              id: `${this.timePackageItem.name.replaceAll(" ", "-")}_${
                this.timePackageItem.id
              }`,
            },
          });
        } else {
          this.$router.push({
            name: "VideosDemoExtendedSubscription",
            params: {
              course: this.timePackageItem,
              path:
                currentRouteName && currentRouteName === "CoursesExtended"
                  ? "subskrypcja-rozszerzona"
                  : timePackageItem.movieSubcategoryL2
                  ? `podkategoria/${timePackageItem.movieSubcategoryL2.id ||
                      timePackageItem.movieSubcategoryL2}`
                  : this.selectedSubCategoryId
                  ? `kategoria/${this.selectedSubCategoryId}`
                  : "subskrypcja-rozszerzona",
            },
            query: {
              id: `${this.timePackageItem.name.replaceAll(" ", "-")}_${
                this.timePackageItem.id
              }`,
            },
          });
        }
      } else if (this.isSubcategory) {
        window.localStorage.setItem(
          "selectedCourse",
          `course_${timePackageItem.id}`
        );
        this.$store.dispatch("movieSubCategories/setSelectedMovieSubCategory", {
          movieSubcategory: timePackageItem,
        });
        router.push({
          name: "SubcategoryView",
          params: { id: timePackageItem.id },
          query: { rozszerzona: this.isExtendedSubscription ? 1 : 0 },
        });
      } else {
        this.$store.dispatch(
          "movieSubCategories/getSubCategoryL2Details",
          timePackageItem.id
        );
        router.push({
          name: "SubcategoryL2View",
          params: { id: timePackageItem.id },
          query: { rozszerzona: this.isExtendedSubscription ? 1 : 0 },
        });
      }
    },
  },
};
</script>

<style scoped>
.star {
  color: rgb(172, 165, 165);
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 20px;
  cursor: pointer;
  z-index: 198;
}

.star-gold,
.star:hover {
  color: rgb(248, 204, 9);
}

.card {
  width: 423px;
  height: 280px;
  object-fit: cover;
  position: relative;
  cursor: pointer;
  border-radius: 17px;
  transition: all 0.5s ease;

}

@media screen and (max-width:600px) {
  .card {
  width: 323px;
  height: 220px;


}
}

@media screen and (max-width: 600px) {
  .card {
    width: 323px;
    height: 220px;
  }
}

@media screen and (max-width: 600px) {
  .card {
    width: 323px;
    height: 220px;
  }
}
.card-hidden {
  width: 230px;
  height: 200px;
}

/* .card:hover img {
  opacity: 0.5;
} */
/* .card:hover {
  background: rgba(0, 0, 0, 0.8);
} */
.card:hover .description {
  transform: translateX(0);
}
.nameContent {
  position: absolute;
  bottom: 1.2rem;
  color: #000;
  font-size: 0.7rem;
  background: linear-gradient(270deg, #c4a2a2 0%, #b28a8a 90.06%);
  border-radius: 0px 10px 10px 0px;
  padding: 8px 10px;
}
.numberOfVideos {
  position: absolute;
  bottom: 0rem;
  color: #000;
  font-size: 0.7rem;
  background: linear-gradient(270deg, #c4a2a2 0%, #b28a8a 90.06%);
  border-radius: 0px 10px 10px 0px;
  padding: 8px 10px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.3rem;
}
.numberOfVideos img {
  width: 15px;
  height: 15px;
  opacity: 100% !important;
}

.freeSubscription {
  position: absolute;
  bottom: 0rem;
  left: 0;
  color: #6d6963;
  font-size: 12px;
  background: #d9d9d9;
  border-radius: 0px 17px 0px 17px;
  padding: 8px 10px;
  font-weight: 500;
}

img {
  width: 100%;
  border-radius: 17px;
  height: 100%;
  object-fit: cover;
}

.description {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  color: #fff;
  z-index: 100;
  top: 15px;
}
.description h2 {
  width: 100%;
  background: linear-gradient(270deg, #c4a2a2 0%, #b28a8a 90.06%);
  padding: 8px 0;
  text-align: center;
  color: #000;
  margin-top: 20px;
  font-weight: 300;
  font-size: 14px;
}
p {
  padding: 10px 20px;
  text-align: center;
  font-size: 0.9rem;
}
.description {
  transform: translateX(-10000px);
}
/* REDESIGN */

.under-card-text h2 {
  color: #6d6963;
  font-size: 14px;
  font-weight: 600;
  max-width: 423px;
}
.number-of-videos {
  color: #8b857d;
  font-size: 14px;
  font-weight: 400;
}
@media screen and ( max-width:600px) {
  .under-card-text h2 {
    max-width: 283px !important;
  }
}

@media screen and (max-width: 400px) {
  .card {
    height: 200px;
    width: 283px;
  }

  img {
    width: 283px;
  }
  p {
    font-size: 0.8rem;
  }
  .description h2 {
    padding: 5px 0;
    margin-top: 10px;
    font-size: 1.3rem;
  }
}

/* REDESIGN */

.under-card-text h2 {
  color: #6d6963;
  font-size: 14px;
  font-weight: 600;
}
.number-of-videos {
  color: #8b857d;
  font-size: 14px;
  font-weight: 400;
}
</style>
